export default function filterStrategicItems(data = [], filters = {}) {
  const { estadoSelecionado = '', startDate = '', endDate = '' } = filters

  // Garantir que as datas estão no formato correto
  const startDateFull = startDate ? `${startDate}-01` : ''
  const endDateFull = endDate ? `${endDate}-31` : ''

  // Agrupar por item
  const groupedItems = {}

  data.forEach(item => {
    // Aplicar filtros de estado e período
    if (estadoSelecionado && item.stateName !== estadoSelecionado) return

    const itemDate = item.date ? item.date.split('T')[0] : ''

    if (startDate && itemDate < startDateFull) return
    if (endDate && itemDate > endDateFull) return

    const itemName = item.itemName || 'Indefinido'

    if (!groupedItems[itemName]) {
      groupedItems[itemName] = { licitacoes: 0, ganhos: 0, valorVenda: 0 }
    }

    groupedItems[itemName].licitacoes += 1
    if (item.phase === 'GANHOS') groupedItems[itemName].ganhos += 1
    groupedItems[itemName].valorVenda += item.cost || 0
  })

  // Transformar em array e calcular taxa de conversão
  const processedData = Object.keys(groupedItems).map(name => ({
    name,
    licitacoes: groupedItems[name].licitacoes,
    taxaConversao: (groupedItems[name].ganhos / groupedItems[name].licitacoes) * 100,
    valorVenda: groupedItems[name].valorVenda,
  }))

  // Ordenar e pegar os TOP produtos
  const topLicitacoes = processedData.sort((a, b) => b.licitacoes - a.licitacoes).slice(0, 20)
  const topConversao = processedData.sort((a, b) => b.taxaConversao - a.taxaConversao).slice(0, 20)
  const topValorVenda = processedData.sort((a, b) => b.valorVenda - a.valorVenda).slice(0, 20)

  return { topLicitacoes, topConversao, topValorVenda }
}
